import { AsignacionCaja } from "./asignacion-caja";
import { Usuario } from './usuario';
import { Definicion } from "./definicion";

export class ArqueoCaja {
	constructor(
        public id: String = "",
        public valor: number = 0,
        public tipo: String = "",
        public fecha: String = "",
        public observacion: String = "",
        public definicion_id: String = "",
        public empresa_id: String = "",
        public sucursal_id: String = "",
        public asignacion_caja_id: String = "",
        public status: String = "",
        public fecha_ingreso: String = "",
        public usuario_id: String = "",
        public fecha_modifica: String = null,
        public usuario_modifica_id: String = null,
        public fecha_elimina: String = null,
        public usuario_elimina_id: String = null,
        public usuario_reposicion_id: String = null,
        public asignacion: AsignacionCaja = new AsignacionCaja(),
        public usuario: Usuario = new Usuario(),
        public definicion: Definicion = new Definicion(),
	)
	{

    }
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/arqueo_caja.ts